import React from "react";
import "./tech.scss";

export default function Tech () {
    return (
        <>
<div class="container1" id="tech">
    <h2 className="heading1">Tech Stack</h2>
	
	<div class="container__progressbars">

		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-pen shadow-pen"> </circle>
			</svg>
			<span class="progressbar__text shadow-pen">Pentration Testing</span>
		</div>

		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-bug shadow-bug"> </circle>
			</svg>
			<span class="progressbar__text shadow-bug">Bug Bounty</span>
		</div>

		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-web shadow-web"> </circle>
			</svg>
			<span class="progressbar__text shadow-web">Web Development</span>
		</div>

		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-js shadow-js"> </circle>
			</svg>
			<span class="progressbar__text shadow-js">JavaScript</span>
		</div>

		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-ts shadow-ts"> </circle>
			</svg>
			<span class="progressbar__text shadow-ts">TypeScript</span>
		</div>

		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-node shadow-node"> </circle>
			</svg>
			<span class="progressbar__text shadow-node">Node.js</span>
		</div>

		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-react shadow-react"> </circle>
			</svg>
			<span class="progressbar__text shadow-react">React.js</span>
		</div>
		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-angular shadow-angular"> </circle>
			</svg>
			<span class="progressbar__text shadow-angular">Angular.js</span>
		</div>
		<div class="progressbar">
			<svg class="progressbar__svg">
				<circle cx="80" cy="80" r="70" class="progressbar__svg-circle circle-vue shadow-vue"> </circle>
			</svg>
			<span class="progressbar__text shadow-vue">Vue.js</span>
		</div>
	</div>

</div>

</>
    );
}


